<efx-modal
  [(show)]="inShowModal"
  [size]="modalSize.large"
  [showFooter]="false"
  [align]="'center'"
  title="Edición masiva"
  [preventDefaultClose]="true"
  (onHide)="closetModal()"
  >
  <section class="d-flex gap-5 flex-column" >
    <form [formGroup]="form">
      @if (!showsucces) {
        <div class="criterio">
          <div class="criterio-counter" formArrayName="camposUpdate">
            @for (atributo of arrayUpdatesControl.controls; track atributo; let i = $index) {
              <div class="w-100">
                <div class="counter-variables" [formGroupName]="i">
                  <div>
                    <label class="efx-label" for="updateSelect">Campo a modificar </label>
                    <select
                      required
                      class="efx-select varWidth"
                      id="updateSelect"
                      formControlName="fieldToChange"
                      (change)="atributo?.get('newValue')?.setValue(null)"
                      #selectFieldToChange
                      >
                      <option value="" disabled hidden>Seleccionar campo</option>
                      @for (struct of structSubDomain; track struct) {
                        <option [value]="struct.name"
                          [ngStyle]="{'color': struct.mkey ? 'var(--efx-status-red)' : 'var(--efx-efx-gray)'  }">
                        {{ struct.label || (struct.name | titlecase) }} </option>
                      }
                    </select>
                  </div>
                  <div class="equal">
                    <p>=</p>
                  </div>
                  <div class="varWidth">
                    <label class="efx-label" for="valor">Nuevo Valor</label>
                    @if (!selectFieldToChange?.value) {
                      <input
                        class="efx-input"
                        type="text"
                        disabled
                        >
                    }
                    @if (selectFieldToChange?.value) {
                      <app-formulario-dinamico
                        id="valor"
                        [formControlador]="atributo.get('newValue')"
                        [offLabel]="true"
                        [structFireBase]="getStructSelect(atributo.get('fieldToChange')?.value)"
                        >
                      </app-formulario-dinamico>
                    }
                  </div>
                  @if (i === 0) {
                    <div class="buttonAdd">
                      <button class="efx-button-primary add" (click)="agregarUpdatesVacio()"><span
                      class="material-symbols-outlined"> add </span>
                    </button>
                  </div>
                }
                @if (i > 0) {
                  <div class="buttonDelete">
                    <button class="efx-button-primary delete" (click)="eliminarUpdate(i)"><span
                    class="material-symbols-outlined"> delete </span></button>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <div class="mt-3">
        <label class="efx-label" for="comentarioAudit">Comentario</label>
        <textarea
          class="efx-textarea w-100"
          id="comentarioAudit"
          formControlName="comentarioAudit"
          cols="40"
          rows="3"
        ></textarea>
      </div>
    }
    @if (showsucces) {
      <section>
        <div class="susses">
          <div>
            <img src="assets/images/check_circle.svg">
          </div>
          <p class="mensaje">Ejecución Realizada con Éxito</p>
          <section class="request" >
            <p class="requestLabel" >RequestId:&nbsp;</p>
            <p class="requestValue">{{ comprobanteBulk?.requestId || 'test' }}</p>
          </section>
        </div>
      </section>
    }
    <div class="d-flex justify-content-end gap-5 mt-4">
      <button class="efx-button-tertiary efx-button-md px-3" (click)="closetModal()">Salir</button>
      @if (!showsucces) {
        <button class="efx-button-primary efx-button-md" [disabled]="disableSave" (click)="onSubmit()">
          <!-- <span class="material-symbols-outlined"> save </span> -->
          Guardar
        </button>
      }
    </div>
  </form>
</section>

</efx-modal>
